module.exports = __webpack_public_path__ + "static/media/workshop.8b3d02d5.svg";